import Vue from "vue";
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';

const mixin = {
    data: () => ({
        sites: [],
        organisations: [],
    }),
    computed: {
        // ...mapGetters({
        //     GET_panelLayout: 'GET_panelLayout',
        // })
    },
    methods: {
        ...mapActions(
            [
                'ACT_panelLayout',
                'ACT_breadcrumbs',
                'ACT_openDocument',
                'ACT_lookupTables',
                'ACT_lookupValues',
                'ACT_usersMA',
                'ACT_usersHosts',
                'ACT_organisations',
                'ACT_openUser',
                'ACT_openConcern',
                'ACT_openFireRollCall',
                'ACT_sites',
                'ACT_projects',
                'ACT_openNotice',
                'ACT_help',
                'ACT_openSlide',
                'ACT_mobileNav',
                'ACT_allUsersHosts'
            ]),

        MIX_mobileNav(payload) {
            this.ACT_mobileNav(payload);
        },

        // * FORMAT DATE TIME
        MIX_formatDateTime: function(date, formatIn, formatOut) {
            if ((date !== '') && (date !== null) && (date !== undefined)) {
                return moment(date, formatIn).format(formatOut);
            } else {
                return ''
            }
        },

        MIX_fromNow: function(date, formatIn, ago) {
            return moment(date, formatIn).fromNow(ago);
        },

        MIX_help(payload) {
            if (payload === true) {
                payload = false;
            } else {
                payload = true;
            }
            //console.log(payload)
            this.ACT_help(payload);
        },


        // * Page Details
        MIX_breadcrumbs(breadcrumbs) {
            this.ACT_breadcrumbs(breadcrumbs);
        },

        // * VIEW RELATED MIXINS
        MIX_closeView() {
            this.MIX_puDialog(false, '', '', '');
            this.MIX_fsDialog(false, ''); // Close Full Screen Dialog
            // this.ACT_panelLayout({ leftPanel: 12, rightPanel: 0, show: false, dynamicComponent: '' });
        },

        MIX_goHome() {
            this.$router.push('/').catch((err) => {
              //  console.log("Route error: " + err);
            });
        },

        MIX_go(path) {
            if (this.GET_currentUser !== null) {
                var userStatus = this.GET_currentUser.userStatus;
                switch (true) {
                    case userStatus === 'PENDING':
                        this.MIX_alert(0, `Account Approval Required for this feature.`, null, null);
                        break;
                    case userStatus === 'APPROVED':
                        this.$router.push(path).catch((err) => {
                            // console.log("Route error: " + err);
                        });
                        break;
                    case userStatus === 'SUSPENDED':
                        this.MIX_alert(-1, `You account is currently suspended.`, null, null);
                        break;
                    case userStatus === 'REJECTED':
                        this.MIX_alert(-1, `You account application has been rejected.`, null, null);
                        break;                    
                }
            } else {
                this.$router.push(path).catch((err) => {
                    // console.log("Route error: " + err);
                });
            }
        },

        // * POPUP USER
        MIX_popupUser(id) {
            var t = this;
            return new Promise(async function (resolve) {
                var userResult = await t.MIX_readDocumentById('users', id)
                var item = {}
                item.process = 'View';
                item.popup = true;
                item.data = userResult.data;
                t.ACT_openUser(item);
                t.MIX_puDialog (true, 'user', '800', '600')
                resolve();
            })
        },

        // * POPUP CONCERN
        MIX_popupConcern(id, process) {
            var t = this;
            return new Promise(async function (resolve) {
                var concern = {}
                concern.process = process;
                if (process !== 'New') {
                    var concernResult = await t.MIX_readDocumentById('concern', id);
                    concern.data = concernResult.data;
                } else {
                    concern.data = null;
                }
                t.ACT_openConcern(concern);    
                t.MIX_puDialog (true, 'concern', '840', '600')
                resolve();
            })
        },

        // * POPUP Notice
        MIX_popupNotice(id, process, popup, forRead) {
            var t = this;
            return new Promise(async function (resolve) {
                var notice = {}
                notice.process = process;
                notice.popup = popup;
                notice.forRead = forRead;
                if (process !== 'New') {
                    var noticeResult = await t.MIX_readDocumentById('notices', id);
                    notice.data = noticeResult.data;
                } else {
                    notice.data = null;
                }
                t.ACT_openNotice(notice);    

                // if ((id !== '') && (id !== null) && (id !== undefined)) {
                //     var noticeResult = await t.MIX_readDocumentById('notices', id)
                //     var notice = {}
                //     notice.process = 'Edit';
                //     notice.popup = true;
                //     notice.data = noticeResult.data;
                //     t.ACT_openNotice(notice);    
                // } else {
                //     var notice = {}
                //     notice.process = 'New';
                //     notice.popup = true;
                //     notice.data = null;
                //     t.ACT_openNotice(notice);    
                // }
                t.MIX_puDialog (true, 'notice', '1000', '1000')
                resolve();
            })
        },





        // * DOWNLOAD FILES
        MIX_downloadFile(url, filename) {
            // cors setup gcloud https://firebase.google.com/docs/storage/web/download-files
            // console.log('downloadPhoto = ' + url)
            this.$axios({ method: 'get', url, responseType: 'arraybuffer' })
            .then((response) => {
                this.MIX_forceFileDownload(response, filename)
            })
            .catch((error) => {
                // console.log('error occured = ' + error))
            });
        },
        MIX_forceFileDownload(response, filename) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
        },

        MIX_testButton() {
            alert('Test Button');
        },

        // * UNDELETE 
        MIX_undelete: async function (collection, title, id) {
            var t = this;
            // console.log(`
            //     colletion: ${collection}
            //     title: ${title}
            //     id: ${id}
            // `)
            var undeleteResult = await t.MIX_undeleteDocument(collection, id)
            if (undeleteResult.code === 1) {
                t.MIX_alert(1, `${title} Restored`, undeleteResult.data, null);
            } else {
                t.MIX_alert(-1, `Error Restoring ${title}`, null, undeleteResult.error);
                // console.log(`undeleteResult.error = ${JSON.stringify(undeleteResult.error, null, 2)}`)
            }
        },
        // * PANEL LAYOUT
        MIX_setPanelLayout(leftPanel, rightPanel, show, title, dynamicComponent) {
            this.ACT_panelLayout({ leftPanel: leftPanel, rightPanel: rightPanel, show: show, title: title, dynamicComponent: dynamicComponent });
        },
        MIX_breakpoint() {
            return (this.$vuetify.breakpoint.name);
        },
        MIX_itemsPerPage: function(breakpoint) {
            var result = 5;
            switch(breakpoint) {
                case 'xs': result = 1; break;
                case 'sm': result = 5; break;
                case 'md': result = 6; break;
                case 'lg': result = 7; break;
                case 'xl': result = 8; break;
                default: result = 5; break;
            }
           return result;            
        },
        // // * OPEN PANEL
        // MIX_openPanel(item, action) {
        //     console.log('Open Panel');
        //     this[action](item);
        //     if (this.$vuetify.breakpoint.lgAndDown) {
        //         this.dialogComponent = 'project';
        //         this.$store.commit('set_dialogPane', { show: false });
        //       } else {
        //         this.dynamicComponent = 'project';
        //         this.MIX_setPanelLayout(6,6,true);
        //       }
        //   },

        // // * CONCERN RELATED MIXINS
        // // OPEN CONCERN
        // MIX_openConcern(item) {
        //     console.log('openProject')
        //     this.ACT_openProject(item);
        //     if (this.$vuetify.breakpoint.lgAndDown) {
        //       this.dialogComponent = 'project';
        //       this.$store.commit('set_dialogPane', { show: false });
        //     } else {
        //       this.dynamicComponent = 'project';
        //       this.MIX_setPanelLayout(6,6,true);
        //     }
        // },


        MIX_filterOnlyCapsText(value, search, item) {
            return (
              value != null &&
              search != null &&
              typeof value === "string" &&
              value
                .toString()
                .toLocaleUpperCase()
                .indexOf(search) !== -1
            );
          },


        MIX_generateId() {
            return "xxxxyxxxyxxxxxxxxx".replace(/[xy]/g, function(c) {
                var r = (Math.random() * 16) | 0,
                v = c == "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        },

            // LOOKUP FIELD (GENERIC)
            MIX_lookupField: function(lookupData, field, value) {
                var t = this;
                var lookupResult = t.$find(lookupData, { value: value })
                if (lookupResult !== undefined) {
                    return (lookupResult)[field];
                } else {
                    return ('NOTFOUND')
                }
            },

        // * PROEJCT RELATED MIXINS
        // NEW PROJECT
        MIX_newProject() {
            // console.log('newProject')
            var project = {}
            this.MIX_openProject(project)
            // if (this.$vuetify.breakpoint.lgAndDown) {
            //   this.dialogComponent = 'project';
            //   this.$store.commit('set_dialogPane', { show: false });
            // } else {
            //   this.dynamicComponent = 'project';
            //   this.MIX_setPanelLayout(6,6,true);
            // }
        },
        // OPEN PROJECT
        MIX_openProject(item) {
            // console.log('openProject')
            this.ACT_openProject(item);
            if (this.$vuetify.breakpoint.lgAndDown) {
              this.dialogComponent = 'project';
              this.$store.commit('set_dialogPane', { show: false });
            } else {
              this.dynamicComponent = 'project';
              this.MIX_setPanelLayout(6,6,true);
            }
        },
        // * DOCUMENT RELATED MIXINS
        // DOCUMENT TABLE
        mix_newDocument() {
            // console.log('newDocument')
            if (this.$vuetify.breakpoint.lgAndDown) {
              this.dialogComponent = 'document-new';
              this.$store.commit('set_dialogPane', { show: false });
            } else {
              this.dynamicComponent = 'document-new';
              this.MIX_setPanelLayout(6,6,true);
            }
        },
        mix_exportDocuments(headers, fileTitle, formatExport) {
            // console.log(formatExport.length);
            var items = formatExport;
            if (headers && items[0] != headers) {
                items.unshift(headers);
            }
            var jsonObject = JSON.stringify(items);
             // convert object to csv
             var array = typeof jsonObject != "object" ? JSON.parse(jsonObject) : jsonObject;
             var str = "";
             for (var i = 0; i < array.length; i++) {
                 var line = "";
                 for (var index in array[i]) {
                 if (line != "") line += ",";
                 line += array[i][index];
                 }
                 str += line + "\r\n";
             }
            var csv = str
            var exportedFilenmae = fileTitle + ".csv" || "export.csv";
            var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, exportedFilenmae);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) {
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", exportedFilenmae);
                link.style.visibility = "hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                }
            }
        },
        MIX_openDocument(item) {
            this.ACT_openDocument(item);
            if (this.$vuetify.breakpoint.lgAndDown) {
              this.$store.commit('set_dialogPane', { show: false });
            } else {
                this.MIX_setPanelLayout(6,6,true);
            }  
        },
        // NEW DOCUMENT
        mix_uploadDocument() {
            alert('DOWNLOAD DOCUMENT');
            // TODO FUNCTION REQUIRED
        },
        mix_saveDocument() {
            alert('SAVE DOCUMENT');
            // TODO FUNCTION REQUIRED
        },
        mix_submitDocument() {
            alert('SUBMIT DOCUMENT');
            // TODO FUNCTION REQUIRED
            //* upload doc 
            var uploadFile = this.$store.getters['upload_file_store/currentFile'];
            this.$firebase.db
                .collection("items")
                .doc()
                .set(uploadFile)
                .then((response) => {
                //success configuration
                // console.log("Your file was succesfully uploaded! " + response);
                })
                .catch((err) => {
                //error configuration
                // console.log(err);
                });
        },
        // EXISTING DOCUMENT
        mix_downloadDocument() {
            alert('DOWNLOAD DOCUMENT');
            // TODO FUNCTION REQUIRED
        },
        mix_commentsDocument() {
            alert('SHOW COMMENTS');
            // TODO FUNCTION REQUIRED
        },
        async MIX_createNotification(type, name, priority, description, linkText, link, recipient, sender) {
            // * create notification
            // console.log('type: ' + type + "\nname: " + name + "\npriority: " + priority + "\ndesc: " + description +'\nlink text: ' + linkText + '\nlink: ' + link + "\nrecipient: " + recipient + "\nsender: " + sender)
            if(priority === '' || priority === null || priority === undefined){
                priority = 'info';
            }
            var notification = {
                type: type,
                name: name,
                priority: priority,
                description: description,
                linkText: linkText,
                link: link,
                read: null,
                recipient: recipient,
                sender: sender
            } 
            var createDocumentResult = await this.MIX_createDocument('notifications', notification);
                if (createDocumentResult.code === 1) {  
                    this.MIX_alert(1, 'Notification send', createDocumentResult.data, null);
                } else {
                    this.MIX_alert(-1, 'ERROR - Could not send notification', null, createDocumentResult.error); 
                }
        },

        mix_approveDocument() {
            alert('APPROVE DOCUMENT');
            this.$store.commit('set_dialogPane', { show: false }); // temporary

            // TODO FUNCTION REQUIRED --- CREATE NOTIFICATION FUNCTION
            // * create notification
            const document = this.$firebase.db.collection("notifications").doc();
            const documentUuid = document.id;

            var notification = {
                notificationId: documentUuid,
                type: ['App', 'Email'],
                name:'Approve Document',
                createdAt: this.$moment().format('DD MMM YY | HH:mm:ss'),
                createdByName: 'Claudia',
                createdByID: 'aw9ur93902fndsk',
                createdByEmail: 'claudia@vindico.net',
                documentId: 'klsihfoewj',
                priority: 'warning',
                description: 'bla bla bla'
            }
            //set notifications
            document.set(notification).then((response) => {
                // console.log('created notif')
            })
            .catch((err) => {
                //error configuration
                // console.log(err);
            });
        },
        mix_rejectDocument() {
            alert('REJECT DOCUMENT');
            // TODO FUNCTION REQUIRED
        },


        // USER WHO ARE MANAGERS & ADMIN        
        MIX_usersMA: function() {
            var t = this;
            return new Promise(async function(resolve) {
                var usersMAResult = await t.MIX_readDocumentsWhere ('users', 
                    [
                        {   key: 'userRole', 'value': ['MANAGER','ADMIN'], 'operator': 'in' } // MANAGER OR ADMIN
                    ])
                var usersMA = [];
                if (usersMAResult.code === 1) {
                    usersMAResult.data.forEach(function(user) {
                        usersMA.push ({
                            userId: user.id,
                            userName: user.userName,
                            userJobTitle: user.userJobTitle,
                            userEmail: user.userEmail,
                            userStatus: user.userStatus,
                            userOrganisation: user.organisation,
                        })
                        //console.log('user = ' + JSON.stringify(user, null, 2))
                    });
                    t.ACT_usersMA(usersMA);
                } else {
                    // console.log(usersMAResult.message)
                }
                resolve();
            })
        },

        // STAFF USER WHO ARE MANAGERS & ADMIN        
        MIX_usersHosts: function() {
            var t = this;
            return new Promise(async function(resolve) {
                var usersHostsResult = await t.MIX_readDocumentsWhere ('users', 
                    [
                        {   key: 'userType', 'value': 'STAFF', 'operator': '==' }, // STAFF
                        {   key: 'userRole', 'value': ['MANAGER','ADMIN'], 'operator': 'in' }, // MANAGER OR ADMIN    
                        {   key: 'userStatus', 'value': 'APPROVED', 'operator': '==' }, // APPROVED ONLY
                    ])
                var usersHosts = [];
                if (usersHostsResult.code === 1) {
                    usersHostsResult.data.forEach(function(user) {
                        //console.log('user = ' + JSON.stringify(user))
                        usersHosts.push ({
                            userId: user.id,
                            userName: user.userName,
                            userJobTitle: user.userJobTitle,
                            userEmail: user.userEmail,
                            userStatus: user.userStatus,
                            userRole: user.userRole,
                            userType: user.userType,
                            userOrganisation: user.organisation,
                        })
                        //console.log('user = ' + JSON.stringify(user, null, 2))
                    });
                    t.ACT_usersHosts(usersHosts);
                } else {
                    // console.log(usersHostsResult.message)
                }
                resolve();
            })
        },

        // STAFF OR ORGANISATION USER WHO ARE MANAGERS & ADMIN        
        MIX_allUsersHosts: function() {
            var t = this;
            return new Promise(async function(resolve) {
                var usersHostsResult = await t.MIX_readDocumentsWhere ('users', 
                    [
                        {   key: 'userRole', 'value': ['MANAGER','ADMIN'], 'operator': 'in' }, // MANAGER OR ADMIN    
                        {   key: 'userStatus', 'value': 'APPROVED', 'operator': '==' }, // APPROVED ONLY
                    ])
                var usersHosts = [];
                if (usersHostsResult.code === 1) {
                    usersHostsResult.data.forEach(function(user) {
                        //console.log('user = ' + JSON.stringify(user))
                        usersHosts.push ({
                            userId: user.id,
                            userName: user.userName,
                            userEmail: user.userEmail,
                            organisationId: user.organisation.organisationId,
                            organisationName: user.organisation.organisationName
                        })
                        //console.log('user = ' + JSON.stringify(user, null, 2))
                    });
                    t.ACT_allUsersHosts(usersHosts);
                } else {
                    // console.log(usersHostsResult.message)
                }
                resolve();
            })
        },
  
        // ORGANISATIONS
        MIX_usersFromOrganisation: function(organisationId) {
            var t = this;
            //console.log('organisationId = ' + organisationId)
            return new Promise(async function(resolve) {
                var usersResult = await t.MIX_readDocumentsByKeyValue('users', 'organisation.organisationId', organisationId)  
                //console.log('usersResult.code = ' + usersResult.code)
                if (usersResult.code === 1) {
                    let users = usersResult.data.map((user) => { 
                        return {
                            'userId': user.id,
                            'userName': user.userName,
                            'userEmail': user.userEmail,
                            'userJobTitle': user.userJobTitle,
                            'organisationId': user.organisationId,
                            'organisationName': user.organisationName,
                            'userStatus': user.userStatus,
                            'userType': user.userType,
                            'userRole': user.userRole
                        }
                    });
                    resolve({code: 1, message: 'Success Got Users From Organisation', data: users, error: null});
                } else {
                    resolve({ code: -1, message: 'ERROR Getting Users from Organisation', data: null, error: usersResult.error})
                }
            })
        },

        // ORGANISATIONS
        MIX_organisations: function() {
            var t = this;
            return new Promise(async function(resolve) {
                var organisationsResult = await t.MIX_readDocuments('organisations');       
                if (organisationsResult.code === 1) {
                    let organisations = organisationsResult.data.map((o) => { return { 'organisationId': o.id, 'organisationName': o.organisationName, 'organisationType': o.organisationType}  });
                    t.ACT_organisations(organisations);
                } else {
                    t.MIX_alert(organisationsResult.code, organisationsResult.message, organisationsResult.data, organisationsResult.error);
                }
                resolve();
            })
        },

        // SITES
        MIX_sites: function() {
            var t = this;
            return new Promise(async function(resolve) {
                var sitesResult = await t.MIX_readDocuments('sites');
                if (sitesResult.code === 1) {
                    let sites = sitesResult.data.map((site) => { 
                        return {
                            'siteId': site.id, 
                            'siteName': site.siteName, 
                            'siteType': site.siteType,
                            'sitePostcode': site.sitePostcode
                        } 
                    });
                    t.ACT_sites(sites);
                } else {
                    t.MIX_alert(sitesResult.code, sitesResult.message, sitesResult.data, sitesResult.error);
                }
                resolve();
            })
        },

        // PROJECTS
        MIX_projects: function(customWhereQuery) {
            var t = this;
            return new Promise(async function(resolve) {
                t.ACT_projects([]);
                //var projectsResult = await t.MIX_readDocuments('projects');   
                //console.log('customWhereQuery = ' + JSON.stringify(customWhereQuery, null, 2))
                var projectsResult = await t.MIX_readDocumentsWhere('projects', customWhereQuery);
                if (projectsResult.code === 1) {
                    let projects = projectsResult.data.map((project) => { 
                        return {
                            'projectId': project.id,
                            'projectName': project.projectName,
                            'projectRef': project.projectRef
                        }  
                    });
                    t.ACT_projects(projects);
                } else {
//                    t.MIX_alert(projectsResult.code, projectsResult.message, projectsResult.data, projectsResult.error);
                }
                resolve();
            })
        },

        // TO DELETE COMMENTS/LOCATIONS/CONCERNS FROM SUBARRAYS
        MIX_deleteCollectionArray(id, item, collection){
            var name = '';
            switch (collection) {
                case 'comments':
                    name = item.comment;
                    break;
                case 'locations':
                    name = item.locationName;
                    break;
                case 'concerns':
                    name = item.locationName;
                    break;
            }
            var title = 'Delete ' + name; 
            var message = 'Are you sure you want to delete the item ' + name + '?';
            var actionDetails = {
                actionName: 'delete',
                collection: collection, // to add delete flag to doc from collection
                itemId: id,
                parentCollection: item.type, // to remove from the item id from the collection
                parentId: item.typeId,           
            }
            
            this.MIX_showConfirmation(true, title, message, 290, "YES", "NO", actionDetails);
        },
        // MIXIN TO LOAD DATABASE DATA INTO LOOKUP TABLES STORE
        MIX_lookupTables: function() {
            var t = this;
            return new Promise(async function(resolve) {
                var lookupTablesResult = await t.MIX_readDocuments('lookupTables');   
                if (lookupTablesResult.code === 1) {
                    t.ACT_lookupTables(lookupTablesResult.data);
                } else {
                    // console.log('ERROR with lookupTablesResult \n' + JSON.stringify(lookupTablesResult, null, 2))
                }
                resolve();
            })
        },
        // MIXIN TO LOAD DATABASE DATA INTO LOOKUP VALUES STORE
        MIX_lookupValues: function() {
            var t = this;
            return new Promise(async function(resolve) {
                // GET LOOKUP VALUES
                var lookupValuesResult = await t.MIX_readDocuments('lookupValues');       
                if (lookupValuesResult.code === 1) {
                    t.ACT_lookupValues(lookupValuesResult.data);
                } else {
                    // console.log('ERROR with lookupValuesResult \n' + JSON.stringify(lookupValuesResult, null, 2))
                }
                resolve();       
            })
        },

        // NOTIFICATIONS MIXINS
        // * determines the no of pages required for an object
        MIX_noOfPages(section, pageSize){
            let l = section.length;
            let s = pageSize;
            return Math.ceil(l/s);
        },
        // * sort by createdDateTime
        MIX_sortByCreatedDateTime(toSortObject) {
            var t = this;
            return toSortObject.sort(function (left, right) {
                return t.$moment(right.createdDateTime, "x").diff(t.$moment(left.createdDateTime, "x"))
            });
        },
        // * filter dates by range
        MIX_filterByDateRange(toBeFilteredObject, start, end){
            var t = this;
           return this.$filter(toBeFilteredObject, function(each){ return t.$moment(each.createdDateTime, 'x').isBetween(start, end);});
        },
        // * remove today/week/month from notifications array
        MIX_hidePreviousNotifications(filteredNotifications, today, week, month){
            return filteredNotifications.filter( function( el ) {
                if(week !== null && month !== null){
                    return !today.includes(el) && !week.includes(el) && !month.includes(el);
                }
                else if( week !== null && month === null){
                    return !today.includes(el) && !week.includes(el);
                }
                else {
                    return !today.includes(el)
                } 
            });
        },
        MIX_capitalizeText(text) {
            var capitalized = text.toLowerCase();
            capitalized = capitalized.charAt(0).toUpperCase() + capitalized.slice(1);  
            return capitalized;
        }

    },
}


export default {
  install (Vue, options) {
    Vue.mixin(mixin)
  }
}